document.addEventListener('DOMContentLoaded', function () {
  // Accordion
  var items = document.querySelectorAll('.cc-pdp__details-item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (this.open) {
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });

  // Mobile carousel dot sync
  var track = document.querySelector('[data-cc-carousel-track]');
  var cards = document.querySelectorAll('[data-cc-carousel-card]');
  var dots = document.querySelectorAll('.cc-pdp__carousel-dot');
  if (track && cards.length && dots.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = Array.prototype.indexOf.call(cards, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        }
      });
    }, { root: track, threshold: 0.5 });
    cards.forEach(function (card) { observer.observe(card); });
  }

  // --- Slots rows: delegate, never dead ---
  //
  // A slots row is a full-width flex container holding two or three 44px
  // buttons, left-packed. Measured on DEV: 81% of the row is empty on
  // nova-birthstone-necklace, and that empty space is the single biggest source
  // of blank dead clicks on the PDPs. The slots themselves are the right size
  // already, so this is an affordance problem, not a miss problem - people tap
  // the general area of the row.
  //
  // Delegated from document because both pickers rebuild their slots with
  // innerHTML on every change, which would discard a listener bound to the row.
  // We only act when the tap missed every slot; a tap that landed on one is left
  // entirely to the picker's own handler.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var row = target.closest('.cc-birthstone-picker__slots, .cc-initial-picker__slots');
    if (!row) return;
    if (target.closest('button')) return;

    var slots = row.querySelectorAll('button');
    if (!slots.length) return;

    // First slot still waiting for a value, else the last one - so a stray tap
    // either continues the selection or reopens the most recent choice to edit.
    var pick = null;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].className.indexOf('--filled') === -1) { pick = slots[i]; break; }
    }
    if (!pick) pick = slots[slots.length - 1];
    pick.click();
  });

  // --- Image lightbox / click-to-enlarge ---
  // Triggers live on BOTH the desktop grid and the mobile carousel; they share
  // the same zoom index per image, so one canonical slide list drives the overlay
  // regardless of which viewport the shopper tapped from.
  var zoomTriggers = document.querySelectorAll('[data-cc-zoom-trigger]');
  if (zoomTriggers.length) {
    var slides = [];
    zoomTriggers.forEach(function (el) {
      var i = parseInt(el.dataset.ccZoomIndex, 10);
      if (isNaN(i)) return;
      // Desktop + mobile write the same data at the same index — last one wins,
      // harmlessly, since the values are identical.
      slides[i] = { src: el.dataset.ccZoomSrc || el.src, alt: el.getAttribute('alt') || '' };
    });
    slides = slides.filter(Boolean);

    if (slides.length) {
      var current = 0;
      var lastFocused = null;
      var multiple = slides.length > 1;

      var overlay = document.createElement('div');
      overlay.className = 'cc-pdp-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image viewer');
      overlay.hidden = true;
      overlay.innerHTML =
        '<button class="cc-pdp-lightbox__close" type="button" aria-label="Close image viewer">×</button>' +
        '<button class="cc-pdp-lightbox__nav cc-pdp-lightbox__nav--prev" type="button" aria-label="Previous image">‹</button>' +
        '<figure class="cc-pdp-lightbox__figure"><img class="cc-pdp-lightbox__img" alt=""></figure>' +
        '<button class="cc-pdp-lightbox__nav cc-pdp-lightbox__nav--next" type="button" aria-label="Next image">›</button>' +
        '<span class="cc-pdp-lightbox__counter" aria-live="polite"></span>';
      document.body.appendChild(overlay);

      var imgEl = overlay.querySelector('.cc-pdp-lightbox__img');
      var counterEl = overlay.querySelector('.cc-pdp-lightbox__counter');
      var closeBtn = overlay.querySelector('.cc-pdp-lightbox__close');
      var prevBtn = overlay.querySelector('.cc-pdp-lightbox__nav--prev');
      var nextBtn = overlay.querySelector('.cc-pdp-lightbox__nav--next');

      if (!multiple) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        counterEl.hidden = true;
      }

      function updateNav() {
        // Hard stops (no wrap): dim + disable the arrow that can't advance.
        // The native `disabled` attribute also blocks the click handler; the
        // keyboard and swipe paths are guarded in next()/prev(), so nav in the
        // dimmed direction is a no-op — matching exactly what the customer sees.
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current === slides.length - 1;
      }
      function show(i) {
        current = Math.max(0, Math.min(i, slides.length - 1)); // clamp, no wrap
        imgEl.src = slides[current].src;
        imgEl.alt = slides[current].alt;
        counterEl.textContent = (current + 1) + ' / ' + slides.length;
        if (multiple) updateNav();
      }
      function openAt(i) {
        lastFocused = document.activeElement;
        show(i);
        overlay.hidden = false;
        document.body.classList.add('cc-pdp-lightbox-open');
        closeBtn.focus();
      }
      function close() {
        overlay.hidden = true;
        document.body.classList.remove('cc-pdp-lightbox-open');
        imgEl.removeAttribute('src'); // release the large image
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }
      function next() { if (current < slides.length - 1) show(current + 1); }
      function prev() { if (current > 0) show(current - 1); }

      zoomTriggers.forEach(function (el) {
        el.addEventListener('click', function () {
          openAt(parseInt(el.dataset.ccZoomIndex, 10) || 0);
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            openAt(parseInt(el.dataset.ccZoomIndex, 10) || 0);
          }
        });
      });

      closeBtn.addEventListener('click', close);
      nextBtn.addEventListener('click', next);
      prevBtn.addEventListener('click', prev);

      // Click on the backdrop or empty figure area (outside the image) closes.
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.classList.contains('cc-pdp-lightbox__figure')) {
          close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (overlay.hidden) return;
        if (e.key === 'Escape') close();
        else if (multiple && e.key === 'ArrowRight') next();
        else if (multiple && e.key === 'ArrowLeft') prev();
      });

      // Mobile swipe left/right to navigate.
      var touchX = null;
      overlay.addEventListener('touchstart', function (e) {
        touchX = e.changedTouches[0].clientX;
      }, { passive: true });
      overlay.addEventListener('touchend', function (e) {
        if (touchX === null || !multiple) { touchX = null; return; }
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        touchX = null;
      }, { passive: true });
    }
  }
});
